/**
 * @graphql agg
 */
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

import type {
	loomUserPermissionQuery$data,
	loomUserPermissionQuery$variables,
} from './__generated__/loomUserPermissionQuery.graphql.ts';

export const LoomUserPermissionQuery: GraphQLTaggedNode = graphql`
	query loomUserPermissionQuery($principalId: String!, $loomResourceId: String!) {
		bulkPermitted(
			principalIds: [$principalId]
			resourceIds: [$loomResourceId]
			permissionIds: ["write"]
		) {
			principalId
			resourceId
			permissionId
			permitted
		}
	}
`;

export const getLoomUserPermissionQueryVariables = (
	cloudId: string,
	userId: string,
): loomUserPermissionQuery$variables => ({
	principalId: `ari:cloud:identity::user/${userId}`,
	loomResourceId: `ari:cloud:loom::site/${cloudId}`,
});

export const hasExactLoomUserPermission = (
	data: loomUserPermissionQuery$data | null | undefined,
	variables: loomUserPermissionQuery$variables,
): boolean => {
	const matchingRows =
		data?.bulkPermitted?.filter(
			(row) =>
				row?.principalId === variables.principalId &&
				row?.resourceId === variables.loomResourceId &&
				row?.permissionId === 'write',
		) ?? [];

	if (matchingRows.length < 1) {
		return false;
	}

	return matchingRows.every((row) => row?.permitted === true);
};
